import React from 'react';

export const SchedulingIndicator = ({ status }) => {
  const colors = {
    'Needs Scheduling': 'bg-[#F8191B]',
    'Requested': 'bg-[#F59E0B]',
    'Granted': 'bg-[#22C55E]',
    'Updated TMS': 'bg-transparent border border-[var(--tms-border)]',
  };
  return (
    <span
      className={`inline-block w-3 h-3 rounded-full flex-shrink-0 ${colors[status] || 'bg-[var(--tms-text-muted)]'}`}
      title={status || 'Unknown'}
    />
  );
};

// Format location as: City, ST Zip - Facility Name
export const formatLocation = (stop, facilities) => {
  if (!stop?.facility_id) return 'N/A';
  const facility = facilities.find(f => f.id === stop.facility_id);
  if (!facility) return stop.facility_name || 'N/A';
  const city = facility.city || '';
  const state = facility.state || '';
  const zip = facility.zip_code || '';
  const name = facility.name || '';
  if (city && state && zip) return `${city}, ${state} ${zip} - ${name}`;
  if (city && state) return `${city}, ${state} - ${name}`;
  return name;
};

// Format short location: City, ST
export const formatShortLocation = (stop, facilities) => {
  if (!stop?.facility_id) return 'N/A';
  const facility = facilities.find(f => f.id === stop.facility_id);
  if (!facility) return 'N/A';
  const city = facility.city || '';
  const state = facility.state || '';
  if (city && state) return `${city}, ${state}`;
  return facility.name || 'N/A';
};

// Format appointment date/time as: MM/DD HH:MM
export const formatAppointmentDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  try {
    const date = new Date(dateTimeStr);
    if (isNaN(date.getTime())) return '';
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${month}/${day} ${hours}:${minutes}`;
  } catch {
    return '';
  }
};

export const ApptTime = ({ value, endTime, testId }) => {
  const start = formatAppointmentDateTime(value);
  const formatted = start && endTime ? `${start}-${endTime}` : start;
  return (
    <span
      className={`shrink-0 font-mono text-[11px] whitespace-nowrap ${formatted ? 'text-[var(--tms-text)] font-semibold' : 'text-[var(--tms-text-muted)] italic'}`}
      data-testid={testId}
    >
      {formatted || 'No appt'}
    </span>
  );
};

// Days a trailer has been dropped (dropped -> ready-for-PU, or today if still waiting)
export const dropDays = (stop) => {
  if (!stop?.drop_off || !stop.trailer_dropped_date) return null;
  try {
    const start = new Date(stop.trailer_dropped_date);
    const end = stop.trailer_ready_for_pickup_date ? new Date(stop.trailer_ready_for_pickup_date) : new Date();
    return Math.max(0, Math.round((end - start) / 86400000));
  } catch { return null; }
};
